import { useStyletron } from "baseui";
import { Block } from "baseui/block";
import { Button } from "baseui/button";
import { Plus } from "baseui/icon";
import { BEHAVIOR, Cell, Grid } from "baseui/layout-grid";
import { useState } from "react";
import { AccessRoles, useHasRole } from "../../../../hooks/useHasRole";
import { RelationsInViewGrid } from "../../../components/RelationsView/RelationsInViewGrid";
import AddBacnetDeviceDialog from "./AddBacnetDeviceDialog";
import { FormattedMessage } from "react-intl";


export interface BacnetDevicesViewProps {
    parentId: string;
    parentResouceGroupId: string
}

const OverviewPanel = ({ parentId, parentResouceGroupId }: BacnetDevicesViewProps) => {
    const [css, theme] = useStyletron();
    const hasAccessAddDevice = useHasRole(AccessRoles.Object.Delete);
    
    const [isOpen, setIsOpen] = useState(false);
    const [refetchCount, setRefetchCount] = useState(0);

    function onCreated() {
        setIsOpen(false);
        setRefetchCount(refetchCount+1);
    }

    return (
        <div className={css({ width: '100%'})}>
        <RelationsInViewGrid parentId={parentId} refetchCnt={refetchCount} resourceGroupId={parentResouceGroupId} relationType='IsConnectedTo'>
            <Cell>
                <Button kind='secondary' disabled={!hasAccessAddDevice} overrides={{
                    BaseButton: {
                        style: ({ $theme }) => ({
                            width: '150px',
                            height: '150px'
                        })
                    }
                }} onClick={() => setIsOpen(true)}>
                    <Block display='flex' flexDirection='column' alignItems='center' gridGap='20px'>
                        <Plus size='2em'></Plus>
                        <FormattedMessage id="BacnetDevicesView.addBacnetDevice" defaultMessage="Add BACnet Device" />
                        
                    </Block>
                </Button>
                <AddBacnetDeviceDialog onCreated={onCreated} isOpen={isOpen} parentId={parentId} parentResouceGroupId={parentResouceGroupId} setIsOpen={setIsOpen}></AddBacnetDeviceDialog>
            </Cell>
        </RelationsInViewGrid>
        </div>
    )
}

export default OverviewPanel;